import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { FacadeService } from 'src/app/core/services/facade.service';
import { ReportLabelEnum } from 'src/app/shared/enums/report-label-enum';
import { MOptimReport } from 'src/app/shared/models/m-optim-report';
import {
	CriteriaReport,
	OptimizationReport
} from 'src/app/shared/models/optimization-report';

@Component({
	selector: 'app-select-solution',
	templateUrl: './select-solution.component.html',
	styleUrls: ['./select-solution.component.scss']
})
export class SelectSolutionComponent {
	// Reference au composant pour qu'il s'auto-ferme en fin de validation
	@Input() modalRefTmpOptimReports: BsModalRef;
	// Labels des boutons de l'application
	@Input() displayAdditionalInfoButtonLabel: string;
	@Input() displayAdditionalInfoButtonLabelInactive: string;
	@Input() displayAdditionalInfoButtonLabelActive: string;
	isDisplayMoreInfoButtonClicked: boolean = false;
	// La date sélectionner, pour le refresh des données du planning après sélection de la solution
	@Input() selectedCalendarDate: Date;
	@Input() tmpOptimReports: MOptimReport[];
	// Refresh des données
	@Output() getDataForPlanning: EventEmitter<any> = new EventEmitter();

	selectedOptimReportId: string;
	reportLabelEnum = ReportLabelEnum;
	optimReport: OptimizationReport;
	displayedCriteriaReport: CriteriaReport[];

	isBtnValidateChoiceClicked = false;

	sortType: string;
	sortOrder: string;

	constructor(private facade: FacadeService) {}

	selectOptimReport(reportId: string) {
		this.selectedOptimReportId = reportId;
	}

	isDisplayedSpecifiedCriteria(label: string): boolean {
		if (
			this.reportLabelEnum[label] === ReportLabelEnum.WAITING_TIME ||
			this.reportLabelEnum[label] === ReportLabelEnum.TW_LATE_ARRIVAL_TIME
		) {
			return false;
		} else {
			return true;
		}
	}

	/**
	 * Affichage des infos dans le tableau de rapport d'optim
	 * Importance 2 = très important, afficher tout le temps
	 * Importance 1 = moins important, afficher seulement par clique sur le bouton
	 * Importance 0 = ne jamais afficher
	 */
	displayAdditionalInfo(): void {
		this.isDisplayMoreInfoButtonClicked = !this.isDisplayMoreInfoButtonClicked;
	}

	makeOptimReportChoice() {
		this.isBtnValidateChoiceClicked = true;
		this.facade.solutionService
			.makeOptimReportChoice(this.selectedOptimReportId)
			.subscribe((_) => {
				this.getDataForPlanning.emit({
					dateToLoad: this.selectedCalendarDate,
					reloadEmployeesAndVacation: false,
					reloadSolution: true,
					reloadOptimInProgress: true
				});
				this.isBtnValidateChoiceClicked = false;
				this.selectedOptimReportId = null;
				this.modalRefTmpOptimReports.hide();
			});
	}

	/**
	 * Méthode de changement de tri
	 * @param str
	 */
	sortChange(str: string) {
		if (str === this.sortType) {
			if (this.sortOrder === 'asc') {
				this.sortOrder = 'desc';
			} else {
				this.sortOrder = 'asc';
			}
		} else {
			this.sortType = str;
			this.sortOrder = 'asc';
		}
	}
}
